<template>
    <div>
        <h3 class="mb-3 mt-2">Accident Type DropDown</h3>
        <vx-card noShadow noRound>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <vs-input
                        v-model="accident_type.name"
                        label="Name"
                        class="w-full"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.name">
                        {{ api_errors.name.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block">Is Active</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio v-model="accident_type.active" vs-name="active" :vs-value="true">Yes</vs-radio>
                        <vs-radio v-model="accident_type.active" vs-name="active" :vs-value="false" class="mx-3">No</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.active">
                        {{ api_errors.active.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
            <vs-row class="mt-base">
                <vs-col class="text-center">
                    <vs-button @click="save" :disabled="submit_disabled">
                        Save
                    </vs-button>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>

<script>
import { Request } from '../../../utils/requests'

export default {
    data() {
        return {
            accident_type_id: this.$route.params.accident_type_id,

            accident_type: {
                name: null,
                active: true,
            },

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.accident_type_id"(newV, oldV) {
            if (newV == oldV) return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.accident_type_id = this.$route.params.accident_type_id

            if (this.accident_type_id) this.load_data()
            else this.accident_type = {
                name: null,
                active: true,
            }
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.accident_type_get + this.accident_type_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.accident_type = res
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.accident_type_get
            if (this.accident_type_id) {
                request_method = 'PUT'
                url += this.accident_type_id + '/'
            }

            let payload = this.accident_type

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.submit_disabled = false
                    this.accident_type = res
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'accident-type-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>